module.exports = __webpack_public_path__ + "img/pray.5b44dd66.jpg";